import React, {useState} from "react";

import sortBy from "lodash/sortBy";
import {useTranslation} from "react-i18next";

import { Add as AddIcon } from '@vedmarket/ui-kit';
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import {formatCopy} from "utils/typography";

import Invoice from './components/invoice';
import DocumentImportTrigger from './components/document-import';
import Summary from './components/summary';

import {
  useGetInvoices,
} from "../../../../../api/calc";
import {COLORS} from "../../../../../config/constants";


import './packaging.scss';
import {useDemoProductsSummary} from 'components/cabinet/demo/steps/packaging/use-packaging';
import {useCalculationReadOnly} from '../../calculation-read-only';

type Props = {
  handleComplete(): void
  testDriveScenarioSlug?: string
}

// const handleComplete = (hasRemoved?: boolean) => {
//
//   // @ts-ignore
//   if (!orderId) {
//     return
//   }
//
//   if (!isLoadedFirstTime) {
//
//     const resetParams = {
//       packaging: false,
//       delivery: false,
//       customs: false,
//       additional_services: false
//     }
//
//     setCompleted({
//       orderId,
//       common: hasRemoved? invoices?.length !== 1 : true,
//       ...(isSuccess && invoices?.length !== 1 && resetParams)
//     })
//   }
// }


// const handleRemove = () => {
//   if (invoices?.length === 1){
//     handleComplete(true);
//   }
// }

const getInvoicesList = (invoices: InvoiceParamsOutput[], testDriveScenarioSlug?: string) =>
  invoices.map((invoice: InvoiceParamsOutput, index) => {
    return <div className='invoice-container' key={invoice.id}>
      <Invoice
        index={index}
        invoice={invoice}
        openByDefault={index +1 === invoices.length}
        testDriveScenarioSlug={testDriveScenarioSlug}
      />
    </div>
  });

const InvoicesAndProducts = ({handleComplete, testDriveScenarioSlug} : Props) => {

  const { t } = useTranslation()

  const [ showNewInvoiceForm, setShowNewInvoiceForm ] = useState(false);

  const invoices = useGetInvoices();

  const productsCount = invoices.reduce(
    (accumulator, invoice) => accumulator + (invoice?.product_count || 0),
    0
  );

  const sortedInvoices = sortBy(invoices, 'id');

  const shouldShowProductsSummary = useDemoProductsSummary()
  const readOnly = useCalculationReadOnly()

  const handleAddNewInvoice = () => setShowNewInvoiceForm(true);

  const onCloseInvoiceForm = () => {
    setShowNewInvoiceForm(false);
  }

  return <>
    <DocumentImportTrigger onApplied={handleComplete} />
    {sortedInvoices.length > 0 ? (
      <>
        {getInvoicesList(sortedInvoices, testDriveScenarioSlug)}
        {showNewInvoiceForm && <Invoice index={sortedInvoices.length} openByDefault onCloseInvoiceForm={onCloseInvoiceForm} testDriveScenarioSlug={testDriveScenarioSlug}/>}
        {!showNewInvoiceForm && <div className='invoice-actions'>
          <Link
            component='button'
            type='button'
            variant='body2'
            underline={readOnly ? 'none' : 'hover'}
            className='invoice-actions__create'
            disabled={readOnly}
            onClick={readOnly ? undefined : handleAddNewInvoice}
            title={readOnly ? t('calc__message__lockedByApplication') : undefined}
            sx={{
              color: readOnly ? COLORS.LIGHT_TEXT_SECONDARY : COLORS.BLUE,
              '&:disabled': {
                color: COLORS.LIGHT_TEXT_SECONDARY,
              },
            }}
          >
            <AddIcon />
            <Typography component='span' variant='inherit'>
              {formatCopy(t('calc__text__main__createInvoice'))}
            </Typography>
          </Link>
          {' '}
          <Typography component='span' variant='body2'>
            {formatCopy(t('calc__text__documentImport__or'))}
          </Typography>
          {' '}
          <DocumentImportTrigger onApplied={handleComplete} isInline />
        </div>}
      </>)
      : (
        <>
          <Invoice index={0} openByDefault testDriveScenarioSlug={testDriveScenarioSlug} />
        </>
      )}
    {productsCount > 0 && shouldShowProductsSummary && (
      <Summary productsCount={productsCount} handleComplete={handleComplete}/>
    )}
  </>
}

export default InvoicesAndProducts
